import { ReactElement } from "react"

import { GenericCreateCommentsComponent } from "../genericComments/genericCreateComment"

interface IAddApplicationCommentComponentProps {
    applicationId: string
    mutate: () => void
    isLoading: boolean
    isDno: boolean
    createComment: (
        applicationId: string,
        comment: string,
        isDno: boolean
    ) => Promise<void>
}

/** Component for adding a comment to a DNO or Installer application */
export const AddApplicationComment = ({
    applicationId,
    mutate,
    isLoading,
    createComment,
    isDno,
}: IAddApplicationCommentComponentProps): ReactElement => {
    const addComment = (comment: string): Promise<void> =>
        createComment(applicationId, comment, isDno)

    return (
        <GenericCreateCommentsComponent
            mutate={mutate}
            isLoading={isLoading}
            createComment={addComment}
        />
    )
}
